import React from "react";
import { withIssuesConsumer } from "@adsk/acc-issues-common/components/primitive/IssuesConsumer";
import { withFetchParams } from "@adsk/acc-issues-core/state/issuesFetchParams/withFetchParams";
import {
  IssuesListProps,
  IssuesList as IssuesListComponent,
} from "@adsk/acc-issues-list";

export const IssuesList = React.memo(
  withIssuesConsumer(
    withFetchParams<IssuesListProps>({ limit: 200 })(IssuesListComponent)
  )
);
